<template>
	<div>
        <div v-show="parent3Show">
            <Form :model="formItem" :label-width="100" inline>
                <Form-item label="门店编号">
                    <Input type="text" v-model="formItem.stcode"></Input>
                </Form-item>
                <Form-item label="用户名称">
                    <Input type="text" v-model="formItem.realname"></Input>
                </Form-item>
                <Form-item label="手机号">
                    <Input type="text" v-model="formItem.userphone"></Input>
                </Form-item>
                <Form-item label="状态">
                    <Select v-model="formItem.state" style="width:150px">
                        <Option v-for="item in selOption" :key="item.val" :value="item.val">{{item.name}}</Option>
                    </Select>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="init">查询</Button>
                </Form-item>
            </Form>
            <Table border :columns="columns" :data="data"></Table>
            <div class="clearfix page">
                <Page :total="pageTotal" class="fr" @on-change="pageChange" @on-page-size-change="pageSize" :current="formItem.start+1" placement="top" show-elevator show-sizer></Page>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        data(){
        	return{
        		formItem: {
                    woid:this.$route.query.woid,
                    stcode:'',
                    realname:'',
                    userphone:'',
                    state:'',
                    start:0,
                    length:10,
                },
                selOption:[
                    {
                        name:'全部',
                        val:''
                    },{
                        name:'未做',
                        val:0,
                    },{
                        name:'已做',
                        val:1
                    }
                ],
                columns:[
                    {
                        title: '门店编号',
                        key: 'stcode'
                    },{
                        title: '用户名称',
                        key: 'realname'
                    },{
                        title: '用户手机号',
                        key: 'userphone'
                    },{
                        title: '状态',
                        key: 'state'
                    }
                ],
                data:[],
                pageTotal:0,
        	}
        },
        watch:{
            $route(to,from){
                if(to.path == '/taskList/taskChildList'){
                    this.$store.dispatch('parent3ShowFn');
                    this.getData();
                }
            }
        },
        computed: {
            parent3Show () {
                return this.$store.state.parent3Show;
            }
        },
        created(){
            this.$store.dispatch('parent3ShowFn');
            this.getData();
        },
        methods:{
            getData(){
                var _this=this;
                this.$http.get('/web/workorder/getTaskList',{
                    params:_this.formItem
                }).then(function(res){
                    _this.data=res.data;
                    _this.pageTotal=res.recordsTotal;
                    _this.$Message.success('加载成功');
                }).catch(function(res){
                    _this.$Message.error('加载失败');
                })
            },
            pageChange(res){
                this.formItem.start=res-1;
                this.getData();
            },
            pageSize(res){
                this.formItem.length=res;
                this.getData();
            },
            init(){
                this.formItem.start=0;
                this.getData();
            },
        }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/task/taskChildList.vue